module.exports = __webpack_public_path__ + "f490ce2b55532cbf07572a1d0f9387cd.pdf";